export const sameValue = (left, right) => JSON.stringify(left) === JSON.stringify(right);

const NUMBER_FIELDS = [
  ["temperature", "Temperature", 0, 1.5, false],
  ["maxAiRepliesPerThread", "Max AI replies per thread", 0, 100, true],
  ["maxAiRepliesPerContactPerDay", "Max AI replies per contact/day", 0, 100, true],
  ["maxAiAutoRepliesPerThread", "Max AI auto-replies per thread", 0, 100, true],
  ["maxAiAutoRepliesPerContactPerDay", "Max AI auto-replies per contact/day", 0, 100, true],
  ["maxSafeNoSourceFallbacksPerThread", "Max safe no-source fallbacks", 0, 3, true],
  ["maxRetrievedChunks", "Max retrieved chunks", 1, 10, true],
  ["maxOutputTokens", "Max output tokens", 1, 2048, true],
  ["providerTimeoutSeconds", "Provider timeout seconds", 1, 30, true],
  ["maxContextMessages", "Max context messages", 1, 100, true],
  ["leadSessionTimeoutHours", "Lead session timeout hours", 1, 168, true],
];

export function validateSettingsNumbers(form) {
  for (const [key, label, min, max, integer] of NUMBER_FIELDS) {
    const raw = form[key];
    if (key === "leadSessionTimeoutHours" && raw == null) continue;
    const value = Number(raw);
    if (!["string", "number"].includes(typeof raw) || String(raw).trim() === "" || !Number.isFinite(value)
        || value < min || value > max || (integer && !Number.isInteger(value))) {
      return `${label} must be ${integer ? "a whole number" : "a number"} between ${min} and ${max}.`;
    }
  }
  return null;
}

// Three-way comparison: apply only local edits, never an entire stale snapshot.
// Divergent edits start with the server value selected and require explicit review.
export function buildSettingsReview(base, local, latest) {
  const rows = [];
  for (const section of ["form", "policy"]) {
    for (const [key, value] of Object.entries(local[section] || {})) {
      if (sameValue(value, base?.[section]?.[key]) || sameValue(value, latest[section][key])) continue;
      const conflict = !sameValue(base?.[section]?.[key], latest[section][key]);
      rows.push({
        id: `${section}.${key}`, section, key, value,
        savedValue: latest[section][key], conflict,
        label: `${section === "policy" ? "Response policy: " : ""}${key.replace(/([A-Z])/g, " $1").replace(/^./, c => c.toUpperCase())}`,
        choice: conflict ? "saved" : "mine",
      });
    }
  }
  return rows;
}

export function applySettingsReview(latest, rows) {
  const result = { form: { ...latest.form }, policy: { ...latest.policy } };
  for (const row of rows) {
    if (row.choice === "mine") result[row.section][row.key] = row.value;
  }
  return result;
}

export function displaySettingsValue(value) {
  if (value == null || value === "") return "(empty)";
  if (typeof value === "boolean") return value ? "On" : "Off";
  return typeof value === "object" ? JSON.stringify(value) : String(value);
}
